import { Component, Input } from '@angular/core';
import { IPromosEcommerce } from './../../../../private/shared/models/productos';

@Component({
  selector: 'getm-promo-tag-sale',
  templateUrl: './promo-tag-sale.component.html',
  styleUrls: ['./promo-tag-sale.component.scss'],
})
export class PromoTagSaleComponent {

  @Input() set promo(value: IPromosEcommerce) {
    this.promoData = value;
    if (this.promoData.TipoPromocion === 'ESCALERA') {
      this.levelDiscount = (this.promoData.Niveles.reduce((max, actual) => actual.Nivel > max.Nivel ? actual : max).Descuento || 0);
    }
  }
  @Input() color: string = 'getm-category-especiales-del-mes';

  public promoData: IPromosEcommerce = {} as IPromosEcommerce;
  public levelDiscount: number = 0;

  constructor() { }

}
